module.exports = __webpack_public_path__ + "static/media/mail.72d2678f.svg";